import { useState, useEffect, useCallback } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../config/firebase';

export function useEmails(user, folder) {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    if (!user) {
      setEmails([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const folderRef = ref(database, `emails/${user.uid}/${folder}`);
    
    // Use onValue for real-time updates
    // onValue returns an unsubscribe function directly
    const unsubscribe = onValue(
      folderRef,
      (snapshot) => {
        try {
          const folderEmails = snapshot.val() || {};
          const emailsData = Object.entries(folderEmails).map(([id, email]) => ({
            id,
            ...email
          }));

          // Sort by timestamp (newest first)
          emailsData.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
          setEmails(emailsData);
          setLoading(false);
        } catch (err) {
          console.error('Error processing emails:', err);
          setError(err.message);
          setLoading(false);
        }
      },
      (err) => {
        console.error('Error loading emails:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    // Cleanup: unsubscribe when component unmounts or dependencies change
    return () => {
      unsubscribe();
    };
  }, [user, folder, refreshTrigger]);

  const refresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
  }, []);

  return { emails, loading, error, refresh };
}
